function Spinner() {
  return (
      <>
          <img src="/assets/spinner.gif" alt="spinner"
          style={{width: "250px", margin: "auto", display: "block"}}/>
      </>
  )
}
export default Spinner